import React, {useState, useEffect} from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

const fetchAccounts = async (inputValue, vendor) => {
	if (!inputValue) {
		return [];
	}

	let vendorPathName = '';
	switch(vendor) {
		case 'Microsoft':
			vendorPathName = 'ms';
			break;
		case 'AWS':
			vendorPathName = 'aws';
			break;
		default:
	}

	if(vendorPathName === '') {
		return [];
	}

	const response = await axios.post(`${process.env.REACT_APP_HOST_URL}/${vendorPathName}/search/input`, {
		search: inputValue
	});

	const accounts = response.data.data;

	return accounts.map(account => ({
		label: account.name,
		value: account.id
	}));
};

const AccountSelect = props => {
	const { value, vendor, disabled, onChange, reset } = props;
	const [selectedAccount, setSelectedAccount] = useState(value);

	useEffect(() => {
		const load = async () => {
			setSelectedAccount(value);
		};
		load();
	}, [value]);

	useEffect(() => {
		const load = async () => {
			loadOptions('-999');
		};
		load();
	}, [reset]);

	const handleChange = (selectedOption) => {
		setSelectedAccount(selectedOption);
		onChange(selectedOption);
	};

	const loadOptions = (inputValue) => {
		if(vendor && vendor !== '-1' && inputValue && inputValue.length > 1) {
			return fetchAccounts(inputValue, vendor); // Specify the limit here
		}
		return [];
	};

	return (
		<div style={{width: '90%'}}>
			<AsyncSelect
				placeholder="Enter at least 2 characters to search."
				isDisabled={disabled}
				cacheOptions={false}
				loadOptions={loadOptions}
				defaultOptions={!disabled}
				onChange={handleChange}
				value={selectedAccount}
				styles={{
					control: (baseStyles, state) => ({
						...baseStyles,
						backgroundColor: state.isDisabled ? '#F5F9FF' : baseStyles.backgroundColor,
						borderColor: '#D3E1ED',
					}),
					placeholder: (baseStyles, state) => ({
						...baseStyles,
						color: state.isDisabled ? '#B6C3CF' : baseStyles.color,
					}),
					dropdownIndicator: (baseStyles, state) => ({
						...baseStyles,
						color: '#6A8991',
						width: 34,
						height: 34,
					}),
				}}
			/>
		</div>
	);
};

export default AccountSelect;
